import { ROLES } from '@/types/auth';
import type { Admin } from '@/types/auth';
import { getWorkspaceRole } from '@/utils/workspace-role';

/**
 * Global Admin (the Pingco platform account) is the only role that unlocks Admin Settings.
 * Two signals are checked because the backend exposes the role in two places: as a
 * system-scoped role on `GET /me` and as a workspace membership role on `GET /me/workspaces`.
 * Either is sufficient — the system-scoped one is authoritative, the workspace one is what
 * mock mode assigns. Both are normalised, so either backend spelling is accepted.
 *
 * Client-side gating is UX-only; the server must enforce the same rule.
 */
export const isGlobalAdmin = (user: Admin | null, selectedWholesalerId: string | null): boolean => {
  if (user == null) {
    return false;
  }

  return (
    user.roles.includes(ROLES.globalAdmin) ||
    getWorkspaceRole(user, selectedWholesalerId) === ROLES.globalAdmin
  );
};
